<!-- eslint-disable max-len -->
<template>
  <div
    :class="{'show-j-toast' : showToast, 'hide-j-toast' : !showToast}"
    class="j-toast">
    <div :class="`j-toast__line-left ${type} m__r--10`" />
    <img
      :src="require(`@/assets/icon/toast/${type}.svg`)"
      width="23">
    <div class="j-toast__wrap">
      <div class="j-toast__title">{{ title }}</div>
      <div class="j-toast__content">{{ content }}</div>
    </div>
    <div
      class="j-toast__close"
      @click="showToast = false">x</div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-console, no-unused-vars */

export default {
  props: {
  },
  data() {
    return {
      showToast: false,
      title: 'Success',
      content: 'Success create data',
      type: 'success',
    };
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    toggleScreen(data) {
      this.title = data.title;
      this.type = data.type;
      this.content = data.message;

      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 3500);
    },
  },
};
</script>

<style lang="scss">
  .j-toast {
    background: #FFFFFF;
    box-shadow: 0px 2px 7px rgba(126, 126, 126, 0.25);
    border-radius: 10px;
    width: 316px;
    height: max-content;
    display: flex;
    padding: 5px 10px;
    position: fixed;
    top: 55px;
    z-index: 99999;
  }

  .show-j-toast {
    right: 10px !important;
    transition: 0.3s !important;
  }

  .hide-j-toast {
    right: -350px !important;
    transition: 0.3s !important;
  }

  .j-toast__line-left {
    border-radius: 7px;
    width: 9px;
    vertical-align: middle;
  }

  .j-toast__line-left.success {
    background: #A9E1C6;
  }

  .j-toast__line-left.error {
    background: #EEA59B;
  }

  .j-toast__line-left.info {
    background: #FFDBB1;
  }

  .j-toast__wrap {
    margin-left: 10px;
    padding: 6px 0px;
    width: 235px;
  }

  .j-toast__close {
    cursor: pointer;
    height: max-content;
  }

  .j-toast__title {
    font-family: 'Poppins-Medium';
    font-size: 14px;
    color: #606060;
  }

  .j-toast__content {
    font-family: 'Poppins-Regular';
    font-size: 12px;
    color: #A0A0A0;
  }
</style>



// WEBPACK FOOTER //
// src/components/toast/jToast.vue